import { render, staticRenderFns } from "./41loadBeijing.vue?vue&type=template&id=4a8477c1&scoped=true&"
import script from "./41loadBeijing.vue?vue&type=script&lang=js&"
export * from "./41loadBeijing.vue?vue&type=script&lang=js&"
import style0 from "./41loadBeijing.vue?vue&type=style&index=0&id=4a8477c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8477c1",
  null
  
)

export default component.exports